import { gql } from "@apollo/client";

const UPDATE_TERM = gql`
  mutation setupTerm($input: UpdateTerm) {
    updateTerm(input: $input) {
      data
      status
      error
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export { UPDATE_TERM };
